/**
 * Editorial PDP Layout - Mobile Gallery Slider
 * Handles scroll-based navigation for the mobile carousel
 */

if (!customElements.get('editorial-gallery-slider')) {
    class EditorialGallerySlider extends HTMLElement {
        constructor() {
            super();
            this.gallery = null;
            this.dots = null;
            this.items = [];
            this.currentIndex = 0;
        }

        connectedCallback() {
            this.gallery = this.querySelector('.editorial-gallery-viewer');
            this.dots = this.closest('.editorial-gallery-column')?.querySelector('.editorial-slider-dots');

            if (!this.gallery) return;

            this.items = Array.from(this.gallery.querySelectorAll('.product__media-item'));

            if (this.items.length === 0) return;

            this.setupScrollListener();
            this.setupDotNavigation();
        }

        setupScrollListener() {
            if (!this.gallery) return;

            let ticking = false;

            this.gallery.addEventListener('scroll', () => {
                if (!ticking) {
                    window.requestAnimationFrame(() => {
                        this.updateActiveDot();
                        ticking = false;
                    });
                    ticking = true;
                }
            }, { passive: true });
        }

        updateActiveDot() {
            if (!this.dots || !this.gallery) return;

            const scrollLeft = this.gallery.scrollLeft;
            const itemWidth = this.items[0]?.offsetWidth || window.innerWidth;
            const newIndex = Math.round(scrollLeft / itemWidth);

            if (newIndex !== this.currentIndex && newIndex >= 0 && newIndex < this.items.length) {
                this.currentIndex = newIndex;
                this.setActiveDot(newIndex);
            }
        }

        setActiveDot(index) {
            if (!this.dots) return;

            const dotElements = this.dots.querySelectorAll('.editorial-slider-dots__dot');
            dotElements.forEach((dot, i) => {
                dot.classList.toggle('is-active', i === index);
            });
        }

        setupDotNavigation() {
            if (!this.dots) return;

            const dotElements = this.dots.querySelectorAll('.editorial-slider-dots__dot');

            dotElements.forEach((dot, index) => {
                dot.addEventListener('click', () => {
                    this.scrollToItem(index);
                });
            });
        }

        scrollToItem(index) {
            if (!this.gallery || !this.items[index]) return;

            const itemWidth = this.items[0]?.offsetWidth || window.innerWidth;

            this.gallery.scrollTo({
                left: itemWidth * index,
                behavior: 'smooth'
            });
        }
    }

    customElements.define('editorial-gallery-slider', EditorialGallerySlider);
}

// Initialize slider functionality on existing galleries
document.addEventListener('DOMContentLoaded', () => {
    const galleries = document.querySelectorAll('.editorial-product .editorial-gallery-viewer');

    galleries.forEach(gallery => {
        const column = gallery.closest('.editorial-gallery-column');
        if (!column) return;

        const dots = column.querySelector('.editorial-slider-dots');
        if (!dots) return;

        const items = gallery.querySelectorAll('.product__media-item');
        let currentIndex = 0;

        // Scroll listener
        let ticking = false;
        gallery.addEventListener('scroll', () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    const scrollLeft = gallery.scrollLeft;
                    const itemWidth = items[0]?.offsetWidth || window.innerWidth;
                    const newIndex = Math.round(scrollLeft / itemWidth);

                    if (newIndex !== currentIndex && newIndex >= 0 && newIndex < items.length) {
                        currentIndex = newIndex;
                        updateDots(newIndex);
                    }
                    ticking = false;
                });
                ticking = true;
            }
        }, { passive: true });

        // Dot click navigation
        const dotElements = dots.querySelectorAll('.editorial-slider-dots__dot');
        dotElements.forEach((dot, index) => {
            dot.addEventListener('click', () => {
                const itemWidth = items[0]?.offsetWidth || window.innerWidth;
                gallery.scrollTo({
                    left: itemWidth * index,
                    behavior: 'smooth'
                });
            });

            // Add cursor pointer
            dot.style.cursor = 'pointer';
        });

        function updateDots(index) {
            dotElements.forEach((dot, i) => {
                dot.classList.toggle('is-active', i === index);
            });
        }
    });
});
